import { Controller } from "@hotwired/stimulus";

// The admin scrolls an inner overflow container, not the document, so the browser's native
// fragment navigation lands on the page without moving to the target.
export default class extends Controller {
  // Controllers that own their own anchors scroll with their own alignment and retry timing.
  static OWNED_BY_OTHER_CONTROLLERS = [
    '[data-controller~="admin--report--card-highlight"]',
    '[data-controller~="collapsible"]',
  ].join(",");

  connect() {
    // The target may still be rendering when this connects, so wait for a paint.
    requestAnimationFrame(() => this.scrollToHash());
  }

  scrollToHash() {
    const target = document.getElementById(window.location.hash.slice(1));
    if (!target) return;
    if (target.closest(this.constructor.OWNED_BY_OTHER_CONTROLLERS)) return;

    target.scrollIntoView({ block: "center" });
  }
}
